import { Quantity, styled } from '@teko/ds-desktop';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { getEnv } from 'helpers';
import { t } from 'i18n';

export const QuantityBlock = () => {
  const { product, payloadAddToCart, setPayloadAddToCart } =
    useProductDetailState();
  const { uomCodeToDisplayDecimalQuantity } = useTenantConfig();
  const precision =
    product?.uomCode === uomCodeToDisplayDecimalQuantity ? 3 : 0;
  return (
    <Wrapper>
      <div className="quantity-text">{t('Số lượng')}</div>
      <Quantity
        className="quantity-selector"
        disableMinus={payloadAddToCart?.quantity === 1}
        quantity={payloadAddToCart?.quantity || 1}
        setQuantity={(value) => {
          if (value !== payloadAddToCart?.quantity) {
            setPayloadAddToCart?.((prev) => {
              return {
                ...prev,
                quantity: value,
              };
            });
          }
        }}
        onPlus={() => {
          setPayloadAddToCart?.((prev) => {
            return {
              ...prev,
              quantity: (prev.quantity || 1) + 1,
            };
          });
        }}
        onMinus={() => {
          if ((payloadAddToCart?.quantity || 1) - 1 > 0) {
            setPayloadAddToCart?.((prev) => {
              return {
                ...prev,
                quantity: (prev.quantity || 1) - 1,
              };
            });
          }
        }}
        min={Math.pow(10, -precision)}
        {...(getEnv('EPIC_ECOM_489') !== 'enabled'
          ? { decimalSeparator: '.' }
          : {})}
        precision={precision}
        blurOnEnter
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 16px;
  .quantity-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-right: 8px;
    white-space: nowrap;
  }
  .quantity-selector {
    width: 132px !important;
    height: 36px !important;
    .rc-input-number-input {
      border-left: 1px solid #e4e5f0;
      border-right: 1px solid #e4e5f0;
      background-color: white;
    }
  }
`;
